import { httpsCallable } from 'firebase/functions';
import { functions } from '../firebase.js';

// Account deletion is fully SERVER-SIDE (functions/accountDeletion.js —
// Admin SDK), because the client can't do it completely: firestore.rules
// forbid deleting your own wallet doc, purchases/sales subcollections
// aren't client-deletable, and Firebase Auth's client deleteUser() fails
// without a recent login. The callable:
//   • refuses if this account owns a school, or if any buyer still has
//     active access to content this account sold (nothing is deleted in
//     either case — the error says why);
//   • otherwise wipes courses/topics/messages, Storage files, marketplace
//     listings, the users/{uid} tree, the wallet (+ledger), releases the
//     school seat if one was held, and deletes the Firebase Auth account.
// After it resolves, the caller (views/settings.js) signs out explicitly.
const deleteMyAccountFn = httpsCallable(functions, 'deleteMyAccount');

export async function deleteMyAccount() {
  await deleteMyAccountFn({ idempotencyKey: crypto.randomUUID() });
}
